import httpAuth from "@/common/http-common";
import { ResearchParticipant } from "@/views/research/research.types";

class ResearchService {
  async GetParticipantDetails(clientId: number, timezone: string, show: boolean) {
    const { data } = await httpAuth().get<ResearchParticipant[]>(
      '/Research/GetParticipantDetails', { params: {
        clientId: clientId,
        timezone: timezone,
        show: show
      } 
    });
    return data;
  }
}

export default new ResearchService();